import React from "react";

const DEFAULT_SIZES = ["S", "M", "L", "XL", "XXL"];

const SizeSelector = ({ sizes = DEFAULT_SIZES, value, onChange, allLabel = "All", testPrefix = "size" }) => (
  <div className="flex flex-wrap gap-2">
    {allLabel && (
      <button
        type="button"
        onClick={() => onChange("")}
        aria-pressed={value === ""}
        className={`min-h-[44px] rounded-[8px] border px-4 py-2 font-mono text-xs transition ${value === "" ? "border-white bg-white text-black" : "border-white/20 hover:border-white"}`}
        data-testid={`${testPrefix}-all`}
      >
        {allLabel}
      </button>
    )}
    {sizes.map((size) => (
      <button
        type="button"
        key={size}
        onClick={() => onChange(size)}
        aria-pressed={value === size}
        className={`min-h-[48px] min-w-[56px] rounded-[8px] border px-4 py-3 font-mono text-sm transition ${value === size ? "border-white bg-white text-black" : "border-white/20 hover:border-white"}`}
        data-testid={`${testPrefix}-${size}`}
      >
        {size}
      </button>
    ))}
  </div>
);

export default SizeSelector;
